// ImageButton.tsx
import * as React from "react";
import { isActivationKey } from "@learningblocks/shared-components";

const { useState } = React;

interface ImageButtonProps {
  onClick: () => void;
  defaultSrc: string;
  hoverSrc: string;
  pressedSrc: string;
  alt?: string;
  className?: string;
}

const ImageButton: React.FC<ImageButtonProps> = ({
  onClick,
  defaultSrc,
  hoverSrc,
  pressedSrc,
  alt = "",
  className,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  // Choose the right image based on state
  let currentSrc = defaultSrc;
  if (isPressed) {
    currentSrc = pressedSrc;
  } else if (isHovered || isFocused) {
    currentSrc = hoverSrc;
  }

  return (
    <button
      onClick={onClick}
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false); // reset pressed state on exit
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onKeyDown={(e) => {
        if (isActivationKey(e)) {
          setIsPressed(true);
        }
      }}
      onKeyUp={(e) => {
        if (isActivationKey(e)) {
          setIsPressed(false);
        }
      }}
    >
      <img src={currentSrc} alt={alt} />
    </button>
  );
};

export default ImageButton;
